// The formatters only the dashboard has a use for. The amount formatters both apps share
// (formatAmount, formatAmountWithAsset, normalizeAmountInput) live in
// @bitcashier/shared/core/formatters.js — put anything the admin panel would also want there, so
// it cannot drift out of step with the panel that reviews the same numbers.
import Decimal from "decimal.js";

// Ported from src/user/utilities/balances_utility.ts. Balance frames off the websocket can carry
// very small amounts that JSON.parse hands back in exponential notation ("1e-8"); rendering that
// raw would show users "1e-8 BTC", so expand it to plain decimal digits before display.
const SCIENTIFIC = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

export const convertFromScientificFormat = (value) =>
  SCIENTIFIC.test(String(value)) ? new Decimal(value).toFixed() : String(value);

// Is a normalized amount string a number? Unsigned on purpose — an amount is never negative, so a
// leading "-" is invalid input rather than a small number. Apply normalizeAmountInput first; this
// deliberately does not accept the ".5"/"1,5" forms that function exists to resolve.
const NUMERIC_AMOUNT = /^\d*\.?\d+$/;

export const isNumericAmount = (value) => NUMERIC_AMOUNT.test(value);

// A file size the way a person reads one, for telling someone their upload is too big. Units are the
// 1024-based ones the limits themselves are written in (10 * 1024 * 1024), labelled KB/MB as the rest
// of the app's copy does. Whole numbers below a megabyte — nobody needs "819.2 KB" — and one decimal
// above, which is what makes "10.4 MB" against a 10 MB limit read as the near miss it is. A whole
// number stays whole: a limit rendered "10.0 MB" reads like a measurement rather than a rule.
export function formatFileSize(bytes) {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size < 0) return "";
  if (size < 1024) return `${Math.round(size)} B`;
  const kilobytes = size / 1024;
  if (kilobytes < 1024) return `${Math.round(kilobytes)} KB`;
  return `${(kilobytes / 1024).toFixed(1).replace(/\.0$/, "")} MB`;
}
